import React, { useEffect, useState } from "react";
import { Link, Route, Routes } from "react-router-dom";
import AccountSetting from "./AccountSetting";
import BrandSelection from "./BrandSelection";
import CategorySelection from "./CategorySelection";
import PrivacySetting from "./PrivacySetting";
import BrandsAndCategories from "./BrandsAndCategories";
import Network from "../UserProfile/Network";
import { UserAuth } from "../Context";
import Posts from "../UserProfile/Posts";
import PointsStats from "../Points/PointsStats";
import { useFetchUserData } from "../hooks/user/useFetchUserData";
import CategoriesSelection from "../UserProfile/StyelPrefence/CategoriesSelection";
function UserSettings2() {
  const { user } = UserAuth();
  const { userData } = useFetchUserData(user?.uid);
  const [activeTab, setActiveTab] = useState("account");
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderTab = (link, tab, text) => {
    return (
      <div>
        <Link
          className={`userSettingLinks`}
          to={link}
          onClick={() => setActiveTab(tab)}
          style={{
            borderBottom: `2px solid ${
              activeTab === tab ? `rgb(0, 95, 218)` : "transparent"
            }`,
            color: activeTab === tab ? "#005FDA" : "#667085",
          }}
        >
          {text}
        </Link>
      </div>
    );
  };
  const renderTabMobile = (link, tab, text) => {
    return (
      <div>
        <Link
          className={`userSettingLinks`}
          to={link}
          onClick={() => setActiveTab(tab)}
          style={{
            backgroundColor: activeTab === tab ? `#F4F9FF` : "",
            color: activeTab === tab ? "#005FDA" : "black",
            padding: "4px 6px",
            borderRadius: "4px",
          }}
        >
          {text}
        </Link>
      </div>
    );
  };
  return (
    // <div className="col-md-8 col-lg-6 vstack gap-3 text-body mt-0 mt-lg-5 px-3 px-lg-0 me-2">
    <div
      className="vstack text-body"
      style={{
        padding: isSmallScreen ? "0px" : "20px 0px 0px 0px",
      }}
    >
      <style jsx>
        {`
          .userSettingLinks {
            font-family: Inter;
            font-size: 16px;
            line-height: 100%;
            text-align: center;
            display: inline-block;
            padding-bottom: 6px;
            font-weight: 400;
          }
        `}
      </style>
      <div
        className="d-none d-md-block"
        style={{
          fontFamily: "Inter",
          fontWeight: "600",
          fontSize: "24px",
          color: "black",
          lineHeight: "100%",
          paddingBottom: "16px",
        }}
      >
        Profile Settings
      </div>
      {isSmallScreen ? (
        <div
          style={{
            padding: "10px 8px",
            gap: "16px",
            whiteSpace: "nowrap",
            overflowX: "auto",
          }}
          className="d-flex align-items-center my-0 hiddenScrollbar vw-100 border-bottom"
        >
          {renderTabMobile("accountSetting", "account", "Account Settings")}
          {renderTabMobile("privacySetting", "privacy", "Privacy Settings")}
          {renderTabMobile("stylePreferences", "SP", "Style Preferences")}
        </div>
      ) : (
        <div
          style={{
            padding: "16px 0",
            gap: "60px",
            whiteSpace: "nowrap",
            overflowX: "auto",
          }}
          className="d-flex align-items-center my-0 hiddenScrollbar vw-100"
        >
          {renderTab("accountSetting", "account", "Account Settings")}
          {renderTab("privacySetting", "privacy", "Privacy Settings")}
          {renderTab("stylePreferences", "SP", "Style Preferences")}
        </div>
      )}
      <div
        style={{
          padding: isSmallScreen ? (activeTab === "SP" ? "6px" : "16px") : "",
        }}
      >
        <Routes>
          <Route path="/accountSetting" element={<AccountSetting />} />
          {/* <Route path="/brandsAndCategories" element={<BrandsAndCategories />} /> */}
          <Route path="/stylePreferences" element={<CategoriesSelection />} />
          <Route path="/brandSelection" element={<BrandSelection />} />
          <Route path={`/network/:uid`} element={<Network />} />
          <Route path={`/posts/:uid`} element={<Posts />} />
          <Route path="/categorySelection" element={<CategorySelection />} />
          <Route path="/privacySetting" element={<PrivacySetting />} />
          <Route
            path="/pointStats/:uid"
            element={<PointsStats userData={userData} />}
          />
        </Routes>
      </div>
    </div>
  );
}

export default UserSettings2;
